//import { componentsStateType } from "reducer/types";
import { objType } from "types";


export const SET_COMPONENTS_STATE = (payload: objType) => ({
  type: 'SET_COMPONENTS_STATE',
  payload: payload
});


export const SET_DRAGGED_BOX = (payload: number) => ({
  type: 'SET_DRAGGED_BOX',
  payload: payload
});


export const RESET_STATE = () => ({
  type: 'RESET_STATE',
  payload: true
});







 


